import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { rem } from '@utils';

const pulse = keyframes`
  0%, 66.666% {
    transform: scale(1);
    opacity: 0.5;
  }

  33.333% {
    transform: scale(1.666);
    opacity: 1;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${rem(6)};
`;

const Dot = styled.div(
  ({ theme }) => css`
  animation: ${pulse} 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  background: ${theme.palette.primary.main};
  border-radius: 50%;
  will-change: transform, opacity;
  height: ${rem(6)};
  width: ${rem(6)};

  &:nth-of-type(2) {
    animation-delay: 0.5s;
  }
  
  &:nth-of-type(3) {
    animation-delay: 1s;
  }
`
);

export default {
  Wrapper,
  Dot
};
